/**
 * Catalogo de plataformas de delivery (NER-1271).
 *
 * Rappi/UberEats/Glovo quedan en el array con available:false para reactivacion
 * rapida cuando se firmen los contratos comerciales (NER-1234, en hold). En la UI
 * solo se renderizan las que tienen available:true (ver visiblePlatforms); las
 * demas se anuncian en el footer informativo via delivery.platforms.upcoming.
 *
 * Modulo separado de la pagina para poder testear la logica de visibilidad sin
 * arrastrar la cadena de imports de services/api (axios ESM no transpila en jest).
 */
export const PLATFORMS = [
  {
    id: 'pedidosya',
    name: 'PedidosYa',
    icon: '🛵',
    color: '#FF0066',
    available: true,
  },
  {
    id: 'mercado_envios',
    name: 'Mercado Envíos',
    icon: '📦',
    color: '#00B1EA',
    available: true,
    // Reusa el access_token de MercadoPago: no requiere externalStoreId,
    // credenciales separadas, comisión ni modo de operación.
    reusesMpCredentials: true,
  },
  {
    id: 'rappi',
    name: 'Rappi',
    icon: '🛵',
    color: '#FF5A00',
    available: false,
  },
  {
    id: 'ubereats',
    name: 'UberEats',
    icon: '🛵',
    color: '#06C167',
    available: false,
  },
  {
    id: 'glovo',
    name: 'Glovo',
    icon: '🛵',
    color: '#FFC244',
    available: false,
  },
];

// Solo mostramos las plataformas integradas. Las no disponibles
// (Rappi/UberEats/Glovo) se anuncian en el footer informativo.
export const visiblePlatforms = PLATFORMS.filter((p) => p.available);
